import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ChartConfiguration} from "chart.js";

@Component({
  selector: 'app-view-follow-up-assessment',
  templateUrl: './view-follow-up-assessment.component.html',
  styleUrls: ['./view-follow-up-assessment.component.scss']
})
export class ViewFollowUpAssessmentComponent implements OnInit {
   assessmentData: any;
  totalYes?=0
  totalNo?=0
  totalSometimes?=0
  chartconfigurationsArray:any[]=[]
  public doughnutChartLabels: string[] = ['Not able to Cope up', 'Able to Cope up', 'Difficulty in Coping up'];
  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    this.assessmentData = this.data; // A
    console.log('ASSESSMENTS ANSWER',this.assessmentData)
    this.assessmentData.questions?.forEach((it:any)=>{
      if(it.ans=='Yes') this.totalYes!++
      else if(it.ans=='No')this.totalNo!++
      else if (it.ans=='Sometimes')this.totalSometimes!++
    })
    const doughnutChartDatasets= [
      // {data: [10, 10, 10], label:'Graph Title' ,backgroundColor: ["#fbc02d", "#00695c", "#af1111"]},
      {data: [this.totalYes!, this.totalNo, this.totalSometimes], label:'Graph Title' ,backgroundColor: [ "#af1111","#00695c","#fbc02d"]},

      // { data: [ 50, 150, 120 ], label: 'Series B' },
      // { data: [ 250, 130, 70 ], label: 'Series C' }
    ];
    // @ts-ignore
    this.chartconfigurationsArray.push(doughnutChartDatasets)

  }

}
